import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input, Row, Col } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import DepartmentModal from '../../components/modals/DepartmentModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Departments extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {name: ''};
    this.state = {redirect: false, departments: [], filteredDepartments: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getDepartments = this.getDepartments.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getDepartments();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getDepartments() {
    axios.get(`${Configuration.apiServer}/api/v1/departments`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({departments: resp.data, filteredDepartments: resp.data});
    });
  } 

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/departments/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getDepartments();
    });
  }

  handleSearch(event) {
    const departments = this.state.departments.filter(department => {
      return department.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredDepartments: departments});
  }

  handleOpenModal(kind, record) {
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/departments`, {department: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getDepartments();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/departments/${this.state.current.id}`, {department: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getDepartments();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of departments
    const departments = this.state.filteredDepartments.map(department => {
      return (
      <Col md={6} style={{marginBottom: "10px"}} key={`departemt${department.id}`}>
        <Card
          className="department-item"
          actions={[<a href={`/admin/departments/${department.id}`}><Icon type="eye" /></a>, <Icon type="edit" onClick={() => { this.handleOpenModal('edit', department) }} />]}
          key={department.id}
        >
          <Meta
            avatar={<Avatar icon="solution" />}
            title={department.name}
            description={<span className={`cursor text-${Configuration.getStatus(department.status).color}`} onClick={() => { this.handleStatus(department.id) }}>{Configuration.getStatus(department.status).text}</span>}
          />
          <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>{department.profiles.length} usuaros</p>
        </Card>
      </Col>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Departamentos</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <Row gutter={16}>
            {departments}
          </Row>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />

        <DepartmentModal visible={this.state.modalVisible} title={"Nuevo departamento"} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />
      </div>
    );
  }
}

export default Departments;



// WEBPACK FOOTER //
// ./src/pages/admin/Departments.js